import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'reactstrap';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import PreventiveTaskAssigneeFormFields from './PreventiveTaskAssigneeFormFields';

const FORM_NAME = 'PreventiveTaskAssigneeForm';

const selector = formValueSelector(FORM_NAME);

export const PreventiveTaskAssigneeForm = ({
  handleSubmit,
  loading,
  initialValues,
  assignmentScopeValue,
  organizationValue,
  departmentValue,
}) => {
  if (loading) {
    return <Loader />;
  }

  return (
    <Form onSubmit={handleSubmit}>
      <PreventiveTaskAssigneeFormFields
        initialValues={initialValues}
        assignmentScope={assignmentScopeValue}
        organization={organizationValue}
        department={departmentValue}
      />

      <FormFooter
        saveButtonDisabled={loading}
        saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-save'}
      />
    </Form>
  );
};

PreventiveTaskAssigneeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  initialValues: PropTypes.shape({}),

  assignmentScopeValue: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.string,
  ]),

  organizationValue: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.number,
  ]),

  departmentValue: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),
};

PreventiveTaskAssigneeForm.defaultProps = {
  loading: false,
  initialValues: null,
  assignmentScopeValue: null,
  organizationValue: 1,
  departmentValue: null,
};

const mapStateToProps = (state) => ({
  assignmentScopeValue: selector(state, 'assignmentScope'),

  organizationValue: selector(state, 'organizationId'),

  departmentValue: selector(state, 'departmentId'),
});

const formComponent = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(PreventiveTaskAssigneeForm);

export default connect(mapStateToProps)(formComponent);
